module.exports = __webpack_public_path__ + "img/RecordList.af1cf362.png";